/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetSkillRequest = {
  skillId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetSkillRequest$inboundSchema: z.ZodType<
  GetSkillRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  skill_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "skill_id": "skillId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetSkillRequest$Outbound = {
  skill_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetSkillRequest$outboundSchema: z.ZodType<
  GetSkillRequest$Outbound,
  z.ZodTypeDef,
  GetSkillRequest
> = z.object({
  skillId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    skillId: "skill_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getSkillRequestToJSON(
  getSkillRequest: GetSkillRequest,
): string {
  return JSON.stringify(GetSkillRequest$outboundSchema.parse(getSkillRequest));
}
export function getSkillRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetSkillRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetSkillRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetSkillRequest' from JSON`,
  );
}
